import React from 'react';
import { PourcentagesNotation } from '@teetsh/app/src/utils/notationSystems/notationSystems';
import tw, { css } from 'twin.macro';

export const sliderHandle = [
  tw`h-4 top-0 rounded-sm w-2 bg-white border text-sm leading-none`,
  css`
    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);
  `,
];

export function Handle({
  handle: { id, value, percent },
  note,
  getHandleProps,
  noColors = false,
}) {
  const isLocked = value === 100;
  const handleProps = isLocked ? {} : getHandleProps(id);

  return (
    <div
      css={[
        sliderHandle,
        tw`absolute z-[2] text-center mt-[34px] -ml-[5px]`,
        isLocked ? tw`cursor-auto` : tw`cursor-pointer`,
        isLocked &&
          !noColors &&
          tw`bg-positive-intense border-positive-moderate`,
      ]}
      style={{
        left: `${percent}%`,
        ...(isLocked && { backgroundImage: 'none' }),
      }}
      {...handleProps}
    >
      <div tw="flex flex-col items-center gap-1 -mt-10">
        <div
          tw="whitespace-nowrap text-sm font-normal"
          css={[
            noColors
              ? tw`text-neutral-moderate`
              : css`
                  color: ${PourcentagesNotation.getNoteColorContrast(value)};
                `,
          ]}
        >
          {note.label}
        </div>
        <div
          tw="text-sm font-normal -mt-1"
          css={[
            noColors
              ? tw`text-neutral-moderate`
              : css`
                  color: ${PourcentagesNotation.getNoteColorContrast(value)};
                `,
          ]}
        >
          ({value})
        </div>
      </div>
    </div>
  );
}
